import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

  :root {
    --body-primary: ${({ theme }) => theme.colors.body.primary};
    --body-greyLight: ${({ theme }) => theme.colors.body.greyLight};
    --body-greyDark: ${({ theme }) => theme.colors.body.greyDark};

    --text-primary: ${({ theme }) => theme.colors.text.primary};
    --text-secondary: ${({ theme }) => theme.colors.text.secondary};
    --text-tertiary: ${({ theme }) => theme.colors.text.tertiary};
    --text-primaryTwo: ${({ theme }) => theme.colors.text.primaryTwo};
    --text-inactive: ${({ theme }) => theme.colors.text.inactive};
    
    --button-primary: ${({ theme }) => theme.colors.button.primary};
    --button-secondary: ${({ theme }) => theme.colors.button.secondary};
    --button-tertiary: ${({ theme }) => theme.colors.button.tertiary};
    --button-primaryInactive: ${({ theme }) =>
      theme.colors.button.primaryInactive};
    --button-secondaryDark: ${({ theme }) => theme.colors.button.secondaryDark};
  }

  p {
    margin:0;
    padding:0;
  }
`;
